/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blue_Aqua_Porpoise_BlinkInputs */

const fr_blue_aqua_porpoise_blink = /** @type {(inputs: Blue_Aqua_Porpoise_BlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de tickets`)
};

/**

* @param {Blue_Aqua_Porpoise_BlinkInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const blue_aqua_porpoise_blink = /** @type {((inputs?: Blue_Aqua_Porpoise_BlinkInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blue_Aqua_Porpoise_BlinkInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_blue_aqua_porpoise_blink(inputs)
});